import script from "./BuddyListChannelButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./BuddyListChannelButton.vue?vue&type=script&lang=ts&setup=true"

import "./BuddyListChannelButton.vue?vue&type=style&index=0&id=39fb29c4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39fb29c4"]])

export default __exports__